import chat from "./chat";
import modal from "./modal";
import ws from "./ws";

export { chat };
export default {
  ws,
  chat,
  modal
};
